module.exports = __webpack_public_path__ + "static/img/bulb.5e2b6090.svg";